import React from 'react'
import {
  Icon,
  Popup,
  Button,
} from 'semantic-ui-react'

const Selector = ({type, item, onToggleItem, colorAll}) =>
  <span>
    {
      type.map((e,ei)=>
        <span key={ei}>
          <Button.Group>
            {
              e.choices.map((c,ci)=>
                <Popup
                  key={ci}
                  trigger={
                    <Button
                      key={ci}
                      type='button'
                      compact
                      icon
                      color={colorAll||(item&&item[e.id]===c.id)?c.color:null}
                      onClick={()=>onToggleItem(e.id, c.id)}
                    >
                      <Icon name={c.icon}/>
                    </Button>
                  }
                  content={
                    <span>
                      <strong>{e.name}:</strong> {c.name}
                      <p style={{fontSize: '80%'}}>
                        <span style={{color: 'grey'}}>{c.description}</span>
                      </p>
                    </span>
                  }
                />
              )
            }
          </Button.Group>
          {' '}
        </span>
      )
    }
  </span>

export default Selector